import axios from 'axios';
import {
    CreateTaskRemarkRequest,
    CreateTaskRemarkResponse,
    GetTaskSchedulResponse,
    GetTaskScheduleRequest,
    TaskActivity,
    TaskActivityRequest
} from '../schemas';
import { ResponseList } from '../../../models/common/Response';
import { GetTaskInboxRequest, TaskInbox } from '../../../models/link/Task';
import { Task } from '../../../models/link/Link';

export async function getAll(params: GetTaskScheduleRequest) {
    return axios.get<GetTaskSchedulResponse>('/v2/link/task', {
        params,
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH')
        }
    });
}

export async function requestTaskActivity(params: TaskActivityRequest) {
    return axios.get<TaskActivity>('v1/link/task-activity', {
        params,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH') }
    });
}

export async function requestTaskActivityV2(params: TaskActivityRequest) {
    return axios.get<TaskActivity>('v2/link/task-activity', {
        params,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH') }
    });
}

export async function reqestTaskInbox(filter: string) {
    return axios.post<ResponseList<TaskInbox>>('v1/link/task-inbox', null, {
        params: {
            filter
        },
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH'),
            'Content-Type': 'application/json'
        }
    });
}

export async function requestTaskInboxByLinkId(
    linkId: string,
    filter: string,
    body?: GetTaskInboxRequest,
    signal?: AbortSignal
) {
    return axios.post<ResponseList<TaskInbox>>('/v2/link/task-inbox', body ?? null, {
        params: {
            link_id: linkId,
            filter
        },
        signal,
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH'),
            'Content-Type': 'application/json'
        }
    });
}

export async function requestLinkTask(email: string) {
    return axios.get<Task[]>('/v1/task', {
        params: { email },
        headers: { Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH') }
    });
}

export async function requestUserAccountDataByEmailV2(email: string) {
    return axios.get<string>('/v2/link/user-account-data', {
        params: { email },
        headers: { Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH') }
    });
}

export async function requestCloseTask(object_link: string, link_id?: string) {
    return axios.post<{ message: string }>('v1/link/close-task', null, {
        params: {
            object_link,
            link_id
        },
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH'),
            'Content-Type': 'application/json'
        }
    });
}

export async function requestCancelTask(object_link: string, link_id?: string) {
    return axios.post<{ message: string }>('v1/link/cancel-task', null, {
        params: {
            object_link,
            link_id
        },
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH'),
            'Content-Type': 'application/json'
        }
    });
}

export async function requestCloseTaskV2(object_link: string, link_id: string) {
    return axios.post<{ message: string }>('v2/link/close-task', null, {
        params: { object_link, link_id },
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH'),
            'Content-Type': 'application/json'
        }
    });
}

export async function requestCancelTaskV2(object_link: string, link_id: string) {
    return axios.post<{ message: string }>('v2/link/cancel-task', null, {
        params: { object_link, link_id },
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH'),
            'Content-Type': 'application/json'
        }
    });
}

export async function requestUpdateTaskProgressV2(
    object_link: string,
    link_id: string,
    code: string
) {
    return axios.put<{ message: string }>(
        'v2/link/task-progress',
        { code },
        {
            params: { object_link, link_id },
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH'),
                'Content-Type': 'application/json'
            }
        }
    );
}

export async function requestCreateTaskRemarkV2(
    objectLink: string,
    request: CreateTaskRemarkRequest
) {
    return axios.post<CreateTaskRemarkResponse>('v2/link/task-remark', request, {
        params: { object_link: objectLink },
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH'),
            'Content-Type': 'application/json'
        }
    });
}
